import {
  EChatbotPeriodicity,
  IChatbotActionButtonSchema,
  IChatbotMessageInfoBlockSchema,
  IChatbotOnboardingButtonSchema,
} from '../../types/chatbot';
import { TChatbotMenuState } from '../../types/chatbotMenu';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatbotActionTypes {
  SetChatbotRowVersion = 'chatbot/setChatbotRowVersion',
  SetChatbotUnreadMessagesCount = 'chatbot/setUnreadMessagesCount',
  SetChatbotPollingIntervalId = 'chatbot/setPollingIntervalId',
  SetChatbotPeriodicity = 'chatbot/setPeriodicity',
  SetChatbotHasPollAnswers = 'chatbot/setHasPollAnswers',
  ToggleChatbotPeriodicityMenu = 'chatbot/togglePeriodicityMenu',
  SetChatbotMenuText = 'chatbot/setChatbotMenuText',
  SetChatbotMessageInfoBlock = 'chatbot/setChatbotMessageInfoBlock',
  SetChatbotActionButtons = 'chatbot/setActionButtons',
  SetChatbotOnboardingButtons = 'chatbot/setOnboardingButtons',
  SetChatbotMenuActionButtons = 'chatbot/setMenuActionButtons',
  SetChatbotIsTyping = 'chatbot/setIsTyping',
  SetChatbotMessageSending = 'chatbot/messageSending',
  SetChatbotIsOpenEventSent = 'chatbot/isOpenEventSent',
  SetChatbotMenu = 'chatbot/setMenu',
}

export type TToggleChatbotPeriodicityMenu = ITypedReduxAction<
  EChatbotActionTypes.ToggleChatbotPeriodicityMenu,
  boolean
>;

export type TChatbotActions =
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotRowVersion, number>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotUnreadMessagesCount, number>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotPollingIntervalId, number | null>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotPeriodicity, EChatbotPeriodicity>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotHasPollAnswers, boolean>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotMenuText, string>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotMessageInfoBlock, IChatbotMessageInfoBlockSchema | undefined>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotActionButtons, IChatbotActionButtonSchema[]>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotOnboardingButtons, IChatbotOnboardingButtonSchema[]>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotMenuActionButtons, IChatbotActionButtonSchema[]>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotIsTyping, boolean>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotMenu, TChatbotMenuState>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotMessageSending, boolean>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotIsOpenEventSent, boolean>
  | TToggleChatbotPeriodicityMenu;
